import React from 'react';
import { motion } from 'framer-motion';
import { FileTextIcon, GridIcon, CalculatorIcon, CheckSquareIcon, ShieldIcon } from 'lucide-react';
const items = [{
  icon: FileTextIcon,
  title: 'El Manual de Intervención Rápida (PDF)',
  desc: 'Qué hacer minuto a minuto tras una pérdida.'
}, {
  icon: GridIcon,
  title: 'La Matriz de Re-Entry 4/30',
  desc: 'Los 4 filtros exactos para volver al mercado con seguridad.'
}, {
  icon: CalculatorIcon,
  title: 'Guía de Gestión de Daños',
  desc: 'La matemática real para recuperar capital sin sobre-apalancarse.'
}, {
  icon: CheckSquareIcon,
  title: 'Checklist de Auditoría Post-Pérdida',
  desc: '10 preguntas que salvan cuentas.'
}, {
  icon: ShieldIcon,
  title: 'Tu Nueva Armadura Operativa',
  desc: "El sistema de blindaje para que este sea tu último 'día rojo' catastrófico."
}];
export const Deliverables = () => {
  return <section className="py-16 md:py-24 bg-brand-bg relative" data-id="element-13">
      <div className="container mx-auto px-4 max-w-5xl" data-id="element-14">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-10 md:mb-16" data-id="element-15">
          <h2 className="text-3xl sm:text-4xl md:text-5xl mb-3 md:mb-4 px-2" data-id="element-16">
            LO QUE OBTIENES HOY
          </h2>
          <div className="w-20 md:w-24 h-1 bg-brand-red mx-auto" data-id="element-17"></div>
        </motion.div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6" data-id="element-18">
          {items.map((item, index) => {
          const Icon = item.icon;
          return <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.1
          }} className="bg-brand-surface p-5 md:p-6 rounded-xl border border-white/5 hover:border-brand-red/50 transition-all duration-300 group" data-id="element-19">
                <div className="w-11 h-11 md:w-12 md:h-12 bg-brand-red/10 rounded-lg flex items-center justify-center mb-4 md:mb-6 group-hover:bg-brand-red/20 transition-colors" data-id="element-20">
                  <Icon className="w-5 h-5 md:w-6 md:h-6 text-brand-red" data-id="element-21" />
                </div>
                <h3 className="text-lg md:text-xl mb-2 md:mb-3 font-display tracking-wide leading-tight" data-id="element-22">
                  {item.title}
                </h3>
                <p className="text-gray-400 text-sm leading-relaxed" data-id="element-23">
                  {item.desc}
                </p>
              </motion.div>;
        })}
        </div>
      </div>
    </section>;
};